import { FC } from 'react';
import { NextTable } from '@shared/modules/next-table/containers';
import { CashRegisterOperationsTableContext } from '../context';
import { useCashRegisterOperationsTable } from '../hooks';

export const CashRegisterOperationsTable: FC = () => {
  const { columns } = useCashRegisterOperationsTable();
  return <NextTable context={CashRegisterOperationsTableContext} columns={columns} />;
};
